import {FeatureList, GameConfig} from "../../../../GameConfig";
import {AnimUtils} from "../../../../utils/AnimUtils";
import {gsap} from "gsap";

export class SideReelFeature extends PIXI.Container {
    protected _spine: PIXI.spine.Spine;

    private _pushInOutPosY: number = 1200;

    constructor(rowId: number, whichSide: string, featureName: string) {
        super();
        this.rowId = rowId;
        this.side = whichSide;
        this.featureName = featureName;
        this.init();
    }

    private _side: string;

    get side(): string {
        return this._side;
    }

    set side(value: string) {
        this._side = value;
    }

    private _rowId: number;

    get rowId(): number {
        return this._rowId;
    }

    set rowId(value: number) {
        this._rowId = value;
    }

    private _featureName: string;

    get featureName(): string {
        return this._featureName;
    }

    set featureName(value: string) {
        this._featureName = value;
    }

    public pushIn(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            bufferY: number = 278;

        tl.to(this.position, {
            y: ((GameConfig.symbolHeight * this.rowId) + bufferY),
            duration: GameConfig.pushItemDuration
        });

        return tl;
    }

    public pushOut(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this.position, {
            y: this._pushInOutPosY,
            duration: GameConfig.pushItemDuration,
            ease: "sine.inOut",
            onComplete: (): void => {
                this.parent.removeChild(this);
            }
        });

        return tl;
    }

    public toggleTint(applyTint: boolean): void {
        this._spine.tint = applyTint ? 0x999999 : 0xffffff;
    }

    protected playAnimation(animToPlay: string, isLooped: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        let skinsArr: string[] = [];

        if (this.featureName === FeatureList.X2 ||
            this.featureName === FeatureList.X3 ||
            this.featureName === FeatureList.X4 ||
            this.featureName === FeatureList.X5 ||
            this.featureName === FeatureList.X99) {
            if (this.side === "left") {
                skinsArr.push("multiplierLeft");
            } else {
                skinsArr.push("multiplierRight");
            }
            skinsArr.push(this.featureName.toLowerCase());
        } else if (this.featureName === FeatureList.XSPLIT) {
            if (this.side === "left") {
                skinsArr.push("xSplitLeft");
            } else {
                skinsArr.push("xSplitRight");
            }
        } else if (this.featureName === FeatureList.BLANK) {
            if (this.side === "left") {
                skinsArr.push("blankLeft");
            } else {
                skinsArr.push("blankRight");
            }
        }

        tl.add(AnimUtils.playSpineAnimation({
            spineObj: this._spine,
            animation: animToPlay,
            playLoop: isLooped,
            skins: skinsArr
        }));

        return tl;
    }

    private init(): void {
        this.createSpine();
        this.setPosition();
        this.setInitialAnimation();
    }

    private createSpine(): void {
        let spinePath: string = "";

        if (this.featureName === FeatureList.XSPLIT) {
            spinePath = "featureXSplit"
        } else if (this.featureName === FeatureList.XBOMB) {
            spinePath = "featureXBomb"
        } else if (this.featureName === FeatureList.X2 ||
            this.featureName === FeatureList.X3 ||
            this.featureName === FeatureList.X4 ||
            this.featureName === FeatureList.X5 ||
            this.featureName === FeatureList.X99) {
            spinePath = "featureMultipliers";
        } else {
            spinePath = "featureBlank";
        }

        if (spinePath) {
            this._spine = AnimUtils.createNewSpine({
                path: spinePath,
                name: spinePath,
                pos: new PIXI.Point(0, 0),
                initShow: true
            });

            this.toggleTint(true);
            this.addChild(this._spine);
        } else {
            debugger;
            throw new Error("--gg-- check for spinePath - SideReelFeature");
        }
    }

    private setPosition(): void {
        const posX: number = this.side === "left" ? 54 : 667;
        this.position.set(posX, this._pushInOutPosY);
    }

    private setInitialAnimation(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(this.playAnimation("2_idle"));

        return tl;
    }
}